import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsCheckBoxOnSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M1 4a3 3 0 013-3h16a3 3 0 013 3v16a3 3 0 01-3 3H4a3 3 0 01-3-3zm17.707 4.707l-1.414-1.414L10 14.586l-3.293-3.293-1.414 1.414L10 17.414z"
        fill=""
      />
    </svg>
  )
);
SvgActionsCheckBoxOnSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsCheckBoxOnSmall;
